import Boxcontainer from "../../components/box-container/Boxcontainer";
import Header from "../../components/header/Header";
import RequestFeature from "../../components/request-feature/RequestFeature";

function Home() {
    return (
        <>
         <Header />
         <Boxcontainer />
         <RequestFeature />
        </>
    );
}
 
export default Home;